<!---->
<template>
    <div>
        <div class="servebox">
            <div class="inn">
                <img src="@/imgs/service.png" alt="">
            </div>

        </div>
        <div id="card" class="content">
            <div class="box">
                <div class="title">
                    <img src="@/imgs/se1.svg" alt="">
                    <p>购买咨询</p>
                </div>
                <div class="con">
                    <div class="con-top">
                        <div class="left">
                            <p class="pp">扫码咨询</p>
                            <img class="wxCode" src="@/imgs/code1.png" alt="">
                        </div>
                        <div class="right">
                            <div class="pp">客服热线</div>
                            <div class="textBox">
                                <div class="text">0571-85241058</div>
                                <div class="text">18094716037</div>
                                <div class="text">周一至周五 9:30-17:30</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box">
                <div class="title">
                    <img src="@/imgs/se2.svg" alt="">
                    <p>供稿咨询</p>
                </div>
                <div class="con">
                    <div class="con-top">
                        <div class="left">
                            <p class="pp">扫码咨询</p>
                            <img class="wxCode" src="@/imgs/code1.png" alt="">
                        </div>
                        <div class="right">
                            <div class="pp">客服热线</div>
                            <div class="textBox">
                                <div class="text">0571-85241058</div>
                                <div class="text">18094716037</div>
                                <div class="text">周一至周五 9:30-17:30</div>
                            </div>
                        </div>
                    </div>
                    <a href="http://yunshangzg.com/contributor">
                        <p class="bbb">供稿网址：<span>http://yunshangzg.com/contributor</span></p>
                    </a>
                </div>
            </div>
            <div class="box3">
                <div class="left">
                    <img src="@/imgs/se3.svg" alt="">
                    <span>在线咨询</span>
                </div>
                <a href='javascript:__egeelTalk();'> <button class="btn" @click="btn">咨询</button></a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'service',
    components: {},
    data() {
        return {}
    },
    computed: {},
    watch: {},
    methods: {
        btn() {
            this.$nextTick(() => {
                let content = document.querySelector('.content')
                content.style.display = 'none'
            })
        }
    },
    mounted() {
        this.$nextTick(() => {
            // 知识点：如果一个dom元素消失了，那么是无法为其绑定事件的
            let icon = document.querySelector('.servebox')
            let content = document.querySelector('.content')
            let timeoutId = null
            // 鼠标hover上icon，content出现
            icon.addEventListener('mouseenter', (event) => {
                content.style.display = 'block'
            }, false)
            icon.addEventListener('mouseleave', (event) => {
                //不能立即消失，因为，如果鼠标再次hover到content，需要将content再次显示出来，可是这个时候content已经消失了，无法为其绑定上mouseenter事件
                timeoutId = setTimeout(() => {
                    content.style.display = 'none'
                }, 200)
            }, false)
            content.addEventListener('mouseenter', (event) => {
                if (timeoutId) {
                    clearTimeout(timeoutId)
                }
            }, false)
            content.addEventListener('mouseleave', (event) => {
                setTimeout(() => {
                    content.style.display = 'none'
                }, 200)
            }, false)
        });
    },
    created() {
    }
}
</script> 

<style scoped lang='scss'>
// &:hover+#card {
//     visibility: visible;
// }

.servebox {
    position: fixed;
    right: 60px;
    bottom: 100px;
    transition: all .5s;
    border-radius: 50%;
    font-size: 18px;
    height: 60px;
    width: 60px;
    background: #FFFFFF;
    /* color: #fff; */

    box-shadow: 1px 1px 10px 4px #e6e3e3;

    &:hover {
        background-color: #ccc;
    }

    .inn {
        width: 100%;
        height: 100%;
        position: relative;
        border-radius: 50%;

        img {
            width: 24px;
            height: 24px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }


}




#card {
    // box-shadow: 1px 1px 2px 4px #eee;
    display: none;
    position: fixed;
    right: 180px;
    bottom: 50px;
    width: 400px;
    height: 530px;
    border-radius: 5px;
    background-color: #fff;
    z-index: 9999999999;
    padding: 20px;

    .box {
        height: 180px;
        width: 100%;
        margin-bottom: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        &:nth-child(2) {
            height: 216px;
        }

        .title {
            font-size: 16px;
            // font-weight: bold;
            display: flex;
            align-items: center;
            margin-bottom: 20px;

            img {
                margin-right: 10px;
                width: 24px;
                height: 24px;
            }
        }

        .con {
            height: 141px;
            width: 100%;
            background: #F8F8F8;

            &:nth-child(2) {
                height: 178px;
            }

            .con-top {
                padding: 15px 25px;
                height: 141px;
                width: 100%;
                background: #F8F8F8;
                border-radius: 12px;
                display: flex;
                justify-content: space-between;
                position: relative;



                .pp {
                    font-size: 16px;
                    font-weight: bold;
                }


                .wxCode {
                    width: 80px;
                    height: 80px;
                }

                .left {
                    font-size: 16px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: space-between;
                    width: 100px;

                }

                .right {

                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;

                    .textBox {
                        color: #525252;
                        font-size: 14px;
                    }
                }
            }

            .bbb {
                color: #525252;
                font-size: 14px;
                padding-left: 30px;
                padding-bottom: 20px;

                span {
                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }
    }

    .box3 {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .left {
            font-size: 16px;
            display: flex;
            align-items: center;

            img {
                margin-right: 10px;
                width: 24px;
                height: 24px;
            }
        }

        .btn {
            font-size: 17px;
            font-weight: bold;
            margin-top: 12px;
            width: 100px;
            height: 38px;
            border-radius: 20px;
            color: #fff;
            background: #FD2866;
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/components/service.vue